import { http, publicUrl, notify } from 'utils'
import Pusher from 'utils/pusher'
import { set } from 'lodash'

// Authentication mutation imports.
import { SET_AUTHORIZED, SET_AUTHORIZED_PROPERTY } from 'vx/mutations'

// Authentication state.
const state = {
  authorized: false
}

// Authentication state getters.
const getters = {
  authorized: state => state.authorized
}

// Authentication actions.
const actions = {
  initialize () {
    const config = {
      baseURL: publicUrl(),
      disableAutomaticReinitialization: true
    }

    return http.post('session-initialize', {}, config)
  },

  login ({ commit }, payload) {
    return http.post('oauth/token', payload)
      .then((response) => {
        return response
      }).catch((error) => {
        if (error.response.status === 401) {
          notify.error(error.response.data.error_description)
        } else {
          throw new Error(error)
        }
      })
  },

  /**
   * Authorize the user with the given token.
   *
   * @return User
   */
  authorize ({ commit }, token) {
    const config = {
      disableAutomaticReinitialization: true
    }

    return http.post('authorize', { token, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }, config)
      .then((response) => {
        commit(SET_AUTHORIZED, response.data)
        return response
      })
  },

  getClientConfig ({ commit }) {
    return http.get('client')
      .then((response) => {
        return response
      })
  },

  logout ({ commit }) {
    if (Pusher) {
      Pusher.disconnect()
    }
    return http
      .post('oauth/logout')
      .then(response => {
        commit(SET_AUTHORIZED, {
          email: '',
          first_name: '',
          last_name: '',
          phone: '',
          mobile: '',
          id: null,
          found_pickstar: null
        })
      })
  },

  setAuthorizedProperty ({ commit }, { property, value }) {
    commit(SET_AUTHORIZED_PROPERTY, { property, value })
  }
}

// Authentication state mutations.
const mutations = {
  [SET_AUTHORIZED] (state, authorized) {
    state.authorized = authorized
  },

  [SET_AUTHORIZED_PROPERTY] (state, { property, value }) {
    set(state.authorized, property, value)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
